/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=AntBgText&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=AntBgText&lang=js"

import "./index.vue?vue&type=style&index=0&id=28bea13d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28bea13d"]])

export default __exports__